const rightCheck = (rightsToCheck, userRight, campuses) => {
  let isAuthorized = false;

  const userCampuses = userRight.campuses.map(campus => campus.campusId);

  rightsToCheck.forEach(right => {
    if (right === userRight.rightName) {
      if (campuses) {
        campuses.forEach(campusId => {
          if (userCampuses.includes(campusId)) {
            isAuthorized = true;
          }
        });
      } else {
        isAuthorized = true;
      }
    }
  });
  return isAuthorized;
};

const districtRightCheck = (rightsToCheck, userRight) => {
  let isAuthorized = false;

  rightsToCheck.forEach(right => {
    if (right === userRight.rightName) {
      isAuthorized = userRight.isDistrictLevel;
    }
  });
  return isAuthorized;
};

const customPropertiesCheck = (rightsToCheck, customProperties) => {
  return rightsToCheck.some(rightName => customProperties[rightName] === true);
};

export const checkRightsChecker = (userRights, campuses) => rightsToCheck =>
  userRights &&
  userRights.some(userRight => rightCheck(rightsToCheck, userRight, campuses));

export const districtCheckRightsChecker = userRights => rightsToCheck =>
  userRights && userRights.some(userRight => districtRightCheck(rightsToCheck, userRight));

export const checkCustomPropertiesChecker = customProperties => rightsToCheck =>
  Boolean(customProperties) && customPropertiesCheck(rightsToCheck, customProperties);
